import { render, staticRenderFns } from "./intelligence-chat.vue?vue&type=template&id=74f16490&scoped=true&"
import script from "./intelligence-chat.vue?vue&type=script&lang=js&"
export * from "./intelligence-chat.vue?vue&type=script&lang=js&"
import style0 from "./intelligence-chat.vue?vue&type=style&index=0&id=74f16490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f16490",
  null
  
)

export default component.exports